<template>
  <div class="header">
    <div class="header-left">
      <div class="logo">
        <img src="../../assets/LOGO.png">
        <div class="line"></div>
      </div>
      <a href="/#/login" v-show="isA"><span>{{ $t('title') }}</span></a>
      <a href="/#/hcpLogin" v-show="!isA"><span style="margin-left: -21px;">{{ $t('title1') }}</span></a>
    </div>
   <!-- <div class="header-right"  @click="languageFormVisible = true" >
      <div v-show="this.$store.state.langs[0].lang"><img src="../../assets/England.png"> <span>English</span></div>
      <div v-show="this.$store.state.langs[5].lang"><img src="../../assets/Australia.png"> <span>English</span></div>
      <div v-show="this.$store.state.langs[1].lang"><img src="../../assets/China.png"><span>中文</span></div>
      <div v-show="this.$store.state.langs[6].lang"><img src="../../assets/Hongkong.png"><span>English</span></div>
      <div v-show="this.$store.state.langs[2].lang"><img src="../../assets/France.png"><span>English</span></div>
      <div v-show="this.$store.state.langs[3].lang"><img src="../../assets/German.png"><span>English</span></div>
      <div v-show="this.$store.state.langs[4].lang"><img src="../../assets/Swiss.png"><span>English</span></div>
      <div v-show="this.$store.state.langs[7].lang"><img src="../../assets/Hungary.png"><span>English</span></div>
      <div v-show="this.$store.state.langs[8].lang"><img src="../../assets/Italy.png"><span>English</span></div>
      <div v-show="this.$store.state.langs[9].lang"><img src="../../assets/Netherlands.png"><span>English</span></div>
      <div v-show="this.$store.state.langs[10].lang"><img src="../../assets/Norway.png"><span>English</span></div>
      <div v-show="this.$store.state.langs[11].lang"><img src="../../assets/Page 1.png"><span>English</span></div>
      <div v-show="this.$store.state.langs[12].lang"><img src="../../assets/Spain.png"><span>English</span></div>
      <div v-show="this.$store.state.langs[13].lang"><img src="../../assets/Turkey.png"><span>English</span></div>
    </div>
    <el-dialog  :visible.sync="languageFormVisible" :size=dialogSize  id="language-choose" :show-close="false" top="20%">
      <div slot="title" class="language-choose-title">
        <span>{{ $t('chooseLang')}}</span>
        <img src="../../assets/cancel.png" @click="cancelChoose">
      </div>
      <div slot class="language-choose-body">
        <div class="language-group">
          <label>{{ $t('asia') }}</label>
          <hr class="language-form-hr">
          <div class="language" @click="languageChoose(5)">
            <img src="../../assets/Australia.png"><span >Australia -<label>English</label></span>
          </div>
          <div class="language zhType" @click="languageChoose(1)">
            <img src="../../assets/China.png"><span >China -<label>中文简体</label></span>
          </div>
          <div class="language speLang2" @click="languageChoose(6)">
            <img src="../../assets/Hongkong.png"><span >Hongkong (China) -<label>English</label></span>
          </div>
        </div>
        <div class="language-group">
          <label>{{ $t('europe') }}</label>
          <hr class="language-form-hr">
          <div class="language" @click="languageChoose(2)">
            <img src="../../assets/France.png"><span >France -<label>English</label></span>
          </div>
          <div class="language speLang3" @click="languageChoose(3)">
            <img src="../../assets/German.png"><span>Germany (mg/dL) -<label>English</label></span>
          </div>
          <div class="language" @click="languageChoose(7)">
            <img src="../../assets/Hungary.png"><span >Hungary -<label>English</label></span>
          </div>
          <div class="language speLang3" @click="languageChoose(3)">
            <img src="../../assets/German.png"><span>Germany (mmol/L) -<label>English</label></span>
          </div>
          <div class="language" @click="languageChoose(8)">
            <img src="../../assets/Italy.png"><span >Italy -<label>English</label></span>
          </div>
          <div class="language" @click="languageChoose(9)">
            <img src="../../assets/Netherlands.png"><span >Netherlands -<label>English</label></span>
          </div>
          <div class="language" @click="languageChoose(10)">
            <img src="../../assets/Norway.png"><span >Norway -<label>English</label></span>
          </div>
          <div class="language" @click="languageChoose(11)">
            <img src="../../assets/Page 1.png"><span >Portugal -<label>English</label></span>
          </div>
          <div class="language" @click="languageChoose(12)">
            <img src="../../assets/Spain.png"><span >Spain -<label>English</label></span>
          </div>
          <div class="language " @click="languageChoose(4)">
            <img src="../../assets/Sweden.png"><span>Sweden -<label>English</label></span>
          </div>
          <div class="language" @click="languageChoose(13)">
            <img src="../../assets/Turkey.png"><span >Turkey -<label>English</label></span>
          </div>

          <div class="language speLang3" @click="languageChoose(0)">
            <img src="../../assets/England.png"><span>United Kingdom -<label>English</label></span>
          </div>
        </div>
        <hr class="language-form-hr">
      </div>
      <div slot="footer" class="language-choose-footer">
        <button  @click="cancelChoose" >{{ $t('Cancel') }}</button>
      </div>
    </el-dialog>-->
  </div><!--header 结束-->
</template>

<script>
  export default{
    data(){
      return{
        locale:'en',
        languageFormVisible:false,
        isA:true,dialogSize:'tiny',  chooseLang:'',asia:'',europe:'',
      }
    },
    computed:{
      changeLanguage(){
        return this.$store.state.language;
      }
    },
    watch:{
      changeLanguage(val){
        this.$i18n.locale = val;
        //console.log(val);
      }
    },
    methods:{
      //选择语言
      languageChoose(index){
        this.languageFormVisible=false;
        this.$store.commit('changLanguage',index);
      },
      //取消选择
      cancelChoose(){
        this.languageFormVisible=false;
      }
    },
    mounted(){
      this.isA = (this.$route.path ==='/login'||this.$route.path ==='/sign'||this.$route.path ==='/personalApply')?true:false;
      /*if(sessionStorage.getItem('index')){
        let index = JSON.parse(sessionStorage.getItem('index'));
       // this.$store.commit('changLanguage',index);
      }*/
      if(sessionStorage.getItem('udHcp')){
          this.isA = (sessionStorage.getItem('udHcp')==='1')?true:false;
      }
      let win = window.innerWidth;
      this.dialogSize =(win<1850)?'small':'tiny';
    },
  }
</script>

<style scoped>
  .header{
    width:95%;
    height:52px;
    padding-top: 1.5%;
    margin:0 auto 3.5%;
    background-color:transparent ;
  }
  .header-left{
    float:left;
  }
  .logo{
    width:130px;
    height:52px;
    float:left;
  }
  .line{
    float:right;
    height:35px;
    margin-top:9px;
    border-right: 2px solid rgba(0,159,223,0.30);
  }
  .header-left i{
    background:rgba(0,159,223,0.30);
    width:2px;
    height:35px;
  }
  .header-left span{
    float: left;
    height: 52px;
    width:223px;
    line-height: 52px;
    font-size:26px;
    color:#2aace0;
    font-family: SFUIText-Medium;
    letter-spacing:-0.64px;
    text-align:center;
    margin-left: 7.5px;
    overflow: hidden;
  }
  .header-right{
    float: right;
    font-family:SFUIText-Regular;
    cursor:pointer;
  }
  .header-right span{
    font-size:22px;
    float: right;
    text-align:center;
    letter-spacing:-0.54px;
    border:none;
    background:transparent;
    margin-left:10px;
    outline: none;
    height:26px;
    line-height:26px;
    color:#282828;
  }

  /*language对话框*/
  #language-choose{
    font-family:SFUIText-Regular;
  }
  .language-choose-title{
    float: left;
    background-image:linear-gradient(-90deg, #38bcf7 0%, #3fa1f4 100%);
    height:45px;
    line-height: 50px;
    width:100%;
    margin:-20px 30px 0 -20px;
    font-size:18px;
    color:#ffffff;
    letter-spacing:-0.43px;
    position: absolute;
  }
  .language-choose-title span{
    margin-left: 42px;
  }
  .language-choose-title img{
    float: right;
    margin-top:16px;
    cursor: pointer;
    margin-right: 10px;
  }

  .language-choose-body{
    width:100%;
    margin-top: 15px;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.39px;
    text-align:left;
  }
  .language-choose-body label{
    margin-left: 22px;
  }
  .language-group{
    width:100%;
    margin-bottom: 30px;
    float: left;
  }
  .language{
    height:24px;
    width: 40%;
    margin-left: 22px;
    float: left;
    margin-top:20px ;
    cursor: pointer;
  }
  .language img{
    float: left;
    margin-right: 13px;
  }
  .language span {
    display: block;
    padding-top:2px;
    float: left;
  }
  .language-form-hr{
    background:#dedede;
    width:90%;
    height:1px;
    border:none;
    margin:10px 0 0 20px;
  }
  .language label{
    margin-left: 10px;
    color:#55adf8;
  }
  .zhType span{
    padding-top: 0;
  }
  /*目前语言种类较少，用来设计特殊样式*/
  .speLang,.speLang1{
    margin-right: 20%;
  }
  .speLang{
    margin-bottom: 10px;
  }
  .speLang2{
    width: 60%;
  }
  .speLang3{
    width: 50%;
    margin-right: 0;
  }
  .language-choose-footer{
    width:65%;
    margin-top:-16px;
    margin-bottom: 8px;
  }
  .language-choose-footer button{
    background-image:linear-gradient(-90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    color:#fff;
    margin:0 auto;
    border-radius:100px;
    width:150px;
    height:30px;
    border:none;
    outline: none;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// Signheader.vue?f4a69252